import {createElementsByHTML, findAllIn, findIn, matches, on, trigger} from "@elements/dom-utils";
import Modal from "bootstrap/js/dist/modal";
import {getCookieBarHTML, getSelectionHTML} from "./utils";
import {init as baseInit, EVENTS} from "./index";


let _config = window['_config'] || {};
_config.cookieServices || (_config.cookieServices = {});

let cookieBarElement;

export function showCookiesInfo({
    uiServicePermissions,
    onAcceptAll,
    onAcceptNecessary,
    onDecline,
    onPermissionUpdate,
}) {
    if (cookieBarElement) {
        cookieBarElement.removeAttribute('hidden');
        trigger(EVENTS.COOKIE_INFO_SHOWN, cookieBarElement);
        return cookieBarElement;
    }

    cookieBarElement = createElementsByHTML(getCookieBarHTML())[0];

    document.body.appendChild(cookieBarElement);
    // addClass('has-cookie-bar', document.body);

    findAllIn('.js-cookie-bar__accept', cookieBarElement).map(on('click', onAcceptAll));

    findAllIn('.js-cookie-bar__accept-necessary', cookieBarElement).map(on('click', onAcceptNecessary));

    findAllIn('.js-cookie-bar__decline', cookieBarElement).map(on('click', onDecline));

    findAllIn('.js-cookie-bar__detail', cookieBarElement).map(on('click', () => showCookiesSettings({
        uiServicePermissions,
        onPermissionUpdate
    })));

    trigger(EVENTS.COOKIE_INFO_SHOWN, cookieBarElement);

    return cookieBarElement;
}

export function hideCookiesInfo() {
    if (cookieBarElement) {
        cookieBarElement.setAttribute('hidden', 'hidden');
        trigger(EVENTS.COOKIE_INFO_CLOSED, cookieBarElement);
    }
}

// modal
let permissionModalElement;
let permissionModal;

function createPermissionModal({
    uiServicePermissions,
    onPermissionUpdate
}) {
    permissionModalElement = createElementsByHTML(`
        <div class="cookie-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="cookie-modal-title">
            <div class="modal-dialog cookie-modal__dialog">
                <div class="modal-content cookie-modal__content">
                    <div class="modal-header cookie-modal__header">
                        <h3 class="modal-title cookie-modal__title" id="cookie-modal-title">${_config.cookieModal.title}</h3>
                        <button type="button" class="btn-close cookie-modal__close" data-bs-dismiss="modal" title="${_config.cookieModal.close}" aria-label="${_config.cookieModal.close}"> 
                        </button>
                    </div>
                    <div class="modal-body cookie-modal__body">
                        ${getSelectionHTML({services: uiServicePermissions})}
                    </div>
                    <div class="modal-footer cookie-modal__footer"> 
                        <button type="button" class="btn btn-primary js-cookie-modal__save">${_config.cookieModal.save}</button>
                    </div>
                </div>
            </div>
        </div>
    `)[0];

    let globalToggle = findIn('input[name="all"]', permissionModalElement);
    let groupToggles = findAllIn('input[name^="group-"]', permissionModalElement);
    let serviceToggles = findAllIn('input:not([name="all"]):not([name^="group-"])', permissionModalElement);

    if (globalToggle) {
        on('change', () => {
            serviceToggles.filter(isNotDisabled).map(toggle => toggle.checked = !!globalToggle.checked);

            groupToggleStateUpdate();
        }, globalToggle);
    }

    groupToggles.map(on('change', (evt) => {
        let groupToggle = evt.target;
        let toggles = serviceToggles.filter(matches('[data-group="' + groupToggle.dataset.group + '"]'));
        toggles.filter(isNotDisabled).forEach(toggle => toggle.checked = !!matches(':checked', groupToggle));

        globalToggleStateUpdate();
    }));

    serviceToggles.map(on('change', () => {
        groupToggleStateUpdate();
        globalToggleStateUpdate();
    }));

    globalToggleStateUpdate();
    groupToggleStateUpdate();

    function globalToggleStateUpdate() {
        if (globalToggle) {
            if(_config.uncheckGlobalToggleAsDefault){
                globalToggle.checked = false;
            }else{
                globalToggle.checked = serviceToggles.some(matches(':checked'));
            }
        }
    }

    function groupToggleStateUpdate() {
        groupToggles.forEach(function (groupToggle) {
            groupToggle.checked = serviceToggles.some(matches('[data-group="' + groupToggle.dataset.group + '"]:checked'));
        });
    }

    findAllIn('.js-cookie-modal__save', permissionModalElement).map(on('click', function () {
        onPermissionUpdate(serviceToggles.map(input => ({
            name: input.name,
            isAllowed: input.checked
        })));

        hideDetail();
    }));

    document.body.appendChild(permissionModalElement);
    return permissionModalElement;
}

export function showCookiesSettings(params) {
    if (permissionModalElement) {
        permissionModalElement.remove();
    }

    permissionModalElement = createPermissionModal(params);

    permissionModal = new Modal(permissionModalElement, {backdrop: 'static'});
    permissionModal.show();
    trigger(EVENTS.COOKIE_SETTINGS_SHOWN, permissionModalElement);
}

function hideDetail() {
    if (permissionModal) {
        permissionModal.hide();
    }
}

export const init = params => baseInit({
    showCookiesInfo,
    hideCookiesInfo,
    showCookiesSettings,
    ...params
});

// helper
const isNotDisabled = matches(':not([disabled])');

